// Constantes de negócio do domínio de acreditação ONA — nunca hardcodear estes valores nas páginas.

export const STATUS_AVALIACAO = {
  SUPERA: 'supera',
  CONFORME: 'conforme',
  PARCIALMENTE_CONFORME: 'parcialmente_conforme',
  NAO_CONFORME: 'nao_conforme',
};

export const STATUS_AVALIACAO_OPCOES = [
  { value: STATUS_AVALIACAO.SUPERA, label: 'Supera', icon: 'bi-star-fill', iconColor: 'text-warning' },
  { value: STATUS_AVALIACAO.CONFORME, label: 'Conforme', icon: 'bi-check-circle-fill', iconColor: 'text-success' },
  { value: STATUS_AVALIACAO.PARCIALMENTE_CONFORME, label: 'Parcialmente Conforme', icon: 'bi-exclamation-circle-fill', iconColor: 'text-warning' },
  { value: STATUS_AVALIACAO.NAO_CONFORME, label: 'Não Conforme', icon: 'bi-x-circle-fill', iconColor: 'text-danger' },
];

export const STATUS_AVALIACAO_LABELS = STATUS_AVALIACAO_OPCOES.reduce(
  (acc, o) => ({ ...acc, [o.value]: o.label }),
  {}
);

// Farol de prazo (ação corretiva e vigência usam a mesma escala)
export const STATUS_PRAZO = {
  EM_DIA: 'em_dia',
  A_VENCER: 'a_vencer',
  VENCIDO: 'vencido',
};

export const STATUS_PRAZO_LABELS = {
  [STATUS_PRAZO.EM_DIA]: 'Em dia',
  [STATUS_PRAZO.A_VENCER]: 'A vencer',
  [STATUS_PRAZO.VENCIDO]: 'Vencido',
};

export const VIGENCIA_MESES_PADRAO = 12;

// Janela de "próximo do vencimento" nas telas de Vencimentos/Corretivas — usuário escolhe.
export const JANELA_VENCIMENTO_PADRAO_DIAS = 90;
export const OPCOES_JANELA_VENCIMENTO_DIAS = [7, 30, 60, 90];

export const PERFIL_OPCOES = [
  { value: 'admin', label: 'Administrador' },
  { value: 'operador', label: 'Auditor AMGestão' },
  { value: 'auditor_hospital', label: 'Auditor de Hospital' },
  { value: 'cliente', label: 'Equipe do Hospital' },
];

export const HOSPITALAR_LABELS = {
  obrigatorio: 'Obrigatório',
  aplicavel: 'Aplicável',
  nao_aplicavel: 'Não aplicável',
};
